module.exports = __webpack_public_path__ + "media/images/vector-29@2x-371d9adfb00c573f847fd343028754e5.png";